import React, { useState } from 'react';
import { toast } from 'sonner';
import { eventBackend } from '../../services';

interface ModalUpdateProps {
  event_id: number;
  onSave: () => void;
  closeModal: () => void;
}

const UpdateEventModal: React.FC<ModalUpdateProps> = ({ event_id, onSave, closeModal }) => {
  const [statusValue, setStatusValue] = useState<number>(2);
  const [comment, setComment] = useState<string | undefined>();

  const closeWithSave = () => {
    saveAction().then((res) => {
      if (res) {
        onSave(); // Передаем новое фото в callback
        closeModal(); // Закрываем модальное окно
      }
    })
  };

  const saveAction = async () => {
    return new Promise((resolve) => {
      console.log("save");
      if (!comment) {
        toast("Комментарий к изменениям обязателен");
        resolve(false);
        return;
      }
      eventBackend.updateEvent({
        event_id,
        status_id: statusValue,
        comment
      }).then((res) => {
        toast("Событие сохранено");
        resolve(true);
      }).catch((e) => {
        toast("Ошибка");
        resolve(false);
      });
    })

  }


  return (
    <div className="editModal">
      <div className="modalHeading">
        <h3>Обновить статус события</h3>
      </div>
      <form className="columnCenter creationForm">
      <div className="formField formRow">
          <label htmlFor="type">Новый статус:</label>
          <select
            id="selectType"
            name="type_id"
            value={statusValue}
            onChange={(event) => setStatusValue(Number(event.target.value))}
          >
            <option value={2}>Обработано</option>
            <option value={3}>Выполнено</option>
          </select>
        </div>
        <div className="formField formRow commentRow">
        <label htmlFor="description">Комментарий</label>
          <textarea
            id="description"
            name="description"
            value={comment}
            onChange={(event) => setComment(event.target.value)}
          />
        </div>
      </form>
       <div className="flex between btnRow">
          <button className="filterButton" type="button" onClick={closeWithSave}>
            Сохранить
          </button>
          <button className="cancelButton" type="button" onClick={closeModal}>
            Отменить
          </button>
        </div>
    </div>
  );
};

export default UpdateEventModal;